import ExcelJS from 'exceljs';
import { organizeHierarchy } from './tools_helper';
import { WriteItemParams, WriteItemResult, ProcessPalletParams, ProcessPalletResult } from './packingListTypes/types';

const generateHeaderConfiguration = (level: any,CFs:any, page= 1) => {

    const page1 = [
        "UPC",
        "Part Number",
        ...(CFs && CFs.show_ean  === "true" ? ["Ean Code"] : []),
        "Description",
        // "Pcs x Ctn", 
        // "Total Ctn", 
        ...(CFs && CFs.show_style == "true" ? ["Style"] : []),
        ...(CFs && CFs.show_size == "true" ? ["Size"] : []),
        ...(CFs && CFs.show_color  == "true" ? ["Color"] : []),
        ...(CFs && CFs.show_season  == "true" ? ["Season"] : []),
        "Quantity",
        "Weight",
        "Dimension",
        "CBM",
    ];

    const page2 = [
        "Pallet",
        "Description",
        "Cartons",
        // ...(CFs && CFs.show_ean  === "true" ? ["Ean Code"] : []),
        "Total Weight Kg",
        // "Pcs x Ctn", 
        // "Total Ctn", 
        // ...(CFs && CFs.show_style == "true" ? ["Style"] : []),
        // ...(CFs && CFs.show_size == "true" ? ["Size"] : []),
        // ...(CFs && CFs.show_color  == "true" ? ["Color"] : []),
        // ...(CFs && CFs.show_season  == "true" ? ["Season"] : []),
        "Dimension",
        "CBM",
    ];

    const headers = page == 1 ? page1: page2;

    const dynamicHeaders = Array.from({ length: level - 1 }, (_, i) => `dynamic${i + 1}`);
    const allHeaders = [...dynamicHeaders, ...headers];
    
    const orderHeaders: any = {};
    let column = 0;

    allHeaders.forEach(header => {
        const startCol = String.fromCharCode(65 + column); 
        if (header === "Dimension") {
            orderHeaders[header] = `${startCol}8:${String.fromCharCode(65 + column + 2)}8`; 
            orderHeaders["Length"] = `${startCol}9`;
            orderHeaders["Width"] = `${String.fromCharCode(65 + column + 1)}9`;
            orderHeaders["Height"] = `${String.fromCharCode(65 + column + 2)}9`;
            column += 3; 
        } else {
            orderHeaders[header] = `${startCol}8:${startCol}9`;
            column++;
        }
    });

    const lastColLetter = String.fromCharCode(65 + column - 1); // Última columna
    return {
        orderHeaders,
        mergeTitle: `A1:${lastColLetter}1`,
        lastCell: `${lastColLetter}1`,
        lastColumnNumber: column,
        positionLogo: `${String.fromCharCode(65 + column - 3)}3`, 
        positionEmail: `${String.fromCharCode(65 + column - 2)}7` 
    };
};

async function getBase64FromImageURL(url: string): Promise<string> {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
    }

    const blob = await response.blob();
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
        reader.onload = () => resolve((reader.result as string).split(',')[1]); // Retorna la parte base64
        reader.onerror = () => reject(new Error('Error'));
        reader.readAsDataURL(blob);
    });
}

const styleHeaders = {
    border: {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
    },
    font: { bold: true, size: 11, color: { argb: 'FFFFFF' } },
    alignment: { horizontal: 'center', vertical: 'middle' },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0e113e' } },
};
const styleTitle = {
    font: { bold: true, size: 26, color: { argb: 'FFFFFF' } },
    alignment: { horizontal: 'center', vertical: 'middle' },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '0e113e' } },
};

const styleCell = {
    border: {
        top: { style: "thin", color: { argb: "FF000000" } }, // Blanco
        left: { style: "thin", color: { argb: "FF000000" } }, // Blanco
        bottom: { style: "thin", color: { argb: "FF000000" } }, // Blanco
        right: { style: "thin", color: { argb: "FF000000" } }, // Blanco
    },
};
async function addLogo(sheet: any, coordinates: string) {
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    try {
        const logoPath = "/dosan.png";//user.NETWORK_ID == 36451 ? '/dosan.png': '/innobo.png';

        // Convertir la imagen a base64
        const logoBase64 = await getBase64FromImageURL(logoPath);
        if (logoBase64) {
            const imageId = sheet.workbook.addImage({
                base64: logoBase64,
                extension: 'png',
            });

            // Coordenadas para agregar la imagen
            const column = coordinates.charCodeAt(0) - 'A'.charCodeAt(0);
            const row = parseInt(coordinates.slice(1), 10) - 1;
            // height: user.NETWORK_ID == 36451 ? 50:100
            sheet.addImage(imageId, {
                tl: { col: column, row: row },
                ext: { width: 200, height: 50 },
                editAs: 'oneCell',
            });

        }
    } catch (error) {
        console.error('Error adding logo to sheet:', error);
    }
}


function verificarNivel(objetos: any) {
    let nivel = 1; // Nivel inicial
    const paquetes: Set<string> = new Set(); // Conjunto para almacenar paquetes únicos

    function calcularNivel(obj: any, nivelActual: number): number {
        if (obj.CLPackageName) {
            paquetes.add(obj.CLPackageName); // Agregar el paquete al conjunto
        }

        if (!obj.children || obj.children.length === 0) {
            return nivelActual; // No tiene hijos, se queda en el nivel actual
        }

        // Hay hijos, incrementamos el nivel
        let maxNivel = nivelActual + 1;
        obj.children.forEach((child: any) => {
            maxNivel = Math.max(maxNivel, calcularNivel(child, nivelActual + 1));
        });

        return maxNivel;
    }

    objetos.forEach((obj: any) => {
        nivel = Math.max(nivel, calcularNivel(obj, 1));
    });

    // Determinar la descripción del nivel máximo
    let nivelDescripcion;
    if (nivel === 1) nivelDescripcion = 1;
    if (nivel === 2) nivelDescripcion = 2;
    if (nivel === 3) nivelDescripcion = 3;
    if (nivel === 4) nivelDescripcion = 4;

    // Retornar el nivel máximo y los paquetes únicos
    return {
        typeOfCr: nivelDescripcion,
        dynamicColumns: Array.from(paquetes), // Convertir el conjunto en un array
    };
}


async function setHeader(sheet: any, objData: any, options: any = {},configuration:any) {
    const {
        typeOfCr = 1, // "2 Levels", "1 Level", or others
        nameColumn = [],
        styleArray1 = {},
        styleArrayFS = {},
        isPage2 = false, // To toggle between the main and secondary header
    } = options;

    // Helper to merge cells and set values
    const mergeAndSet = (cellRange: any, value: any, style = {}) => {
        sheet.mergeCells(cellRange);
        sheet.getCell(cellRange.split(":")[0]).value = value;
        if (Object.keys(style).length > 0) {
            sheet.getCell(cellRange.split(":")[0]).style = style;
        }
    };


    const keys = ["Pallet","Cartons","Total Weight Kg","UPC", "Part Number","Ean Code","Description","Style","Size","Color","Season","Quantity", "Weight", "Dimension", "Length", "Width", "Height", "CBM", "dynamic1", "dynamic2", "dynamic"]
    const headersPage1: any = [];

    let countHeader = 0;

    for (let i = 0; i <= keys.length - 1; i++) {
        if (keys[i].includes("dynamic")) {
            if (configuration.orderHeaders[keys[i]]) {
                headersPage1.push([`${configuration.orderHeaders[keys[i]]}`,(nameColumn[countHeader] ? nameColumn[countHeader]:"BOX")])
                countHeader++;
            }
        } else {
            if(configuration.orderHeaders[keys[i]]){
                headersPage1.push([`${configuration.orderHeaders[keys[i]]}`, keys[i]])
            }
        }
    }

    // Common Header Setup
    mergeAndSet(configuration.mergeTitle, "PACKING LIST", { ...styleArrayFS });

    // Common Data Rows
    sheet.getCell("A3").value = "Date:";
    sheet.getCell("B3").value = objData.date;
    sheet.getCell("A4").value = "Customer:";
    sheet.getCell("B4").value = objData.customer;
    sheet.getCell("A5").value = "Invoice N°";
    sheet.getCell("B5").value = objData.invoiceN;
    sheet.getCell("A6").value = "Brand:";
    sheet.getCell("B6").value = objData.brand;

    // Special rows for specific customers or data
    if (!isPage2 && objData.customer === "GABE'S" && objData.SupplierPONumber) {
        sheet.getCell("A7").value = "P.O Number:";
        sheet.getCell("B7").value = objData.SupplierPONumber;
    }

    // Header Columns
    const headers: [string, string][] = headersPage1;

    headers.forEach(([range, text]) => mergeAndSet(range, text));

    // Column Width Adjustments
    const columnWidths = isPage2
        ? { A: 20, B: 20, C: 20, D: 20, E: 15, F: 15, G: 15, H: 15 }
        : { A: 20, B: 20, C: 20, D: 20, E: 20, F: 20, G: 20, H: 10, I: 10, J: 10, K: 10, L: 10 };

    Object.entries(columnWidths).forEach(([col, width]) => {
        sheet.getColumn(col).width = width;
    });

    const positionLogo = configuration.positionLogo;

    // Adjust column visibility for specific brands
    // if (!["LEGO", "GOLI"].includes(objData.brand?.toUpperCase())) {
    //     sheet.getColumn("E").width = 0;
    //     if (isPage2) {
    //         sheet.getColumn("F").width = 0;
    //         sheet.getColumn("G").width = 0;
    //     } else {
    //         sheet.getColumn("F").width = 0;
    //     }
    // }

    await addLogo(sheet, positionLogo);

    // Hyperlink
    const positionEmail = configuration.positionEmail;
    sheet.getCell(positionEmail).value = {
        text: "dosancargo.com",
        hyperlink: "https://www.dosancargo.com/",
    };

    // Optional styling for ranges
    // if (isPage2) {
    // Definir el rango de celdas (A9:H10)
    const startRow = 8;
    const endRow =  9;
    const startCol = 1; // A = 1
    const endCol =  configuration.lastColumnNumber; // H = 8

    for (let row = startRow; row <= endRow; row++) {
        for (let col = startCol; col <= endCol; col++) {
            const cell = sheet.getCell(row, col);
            // Aplicar estilos a cada celda
            cell.style = {
                ...styleArray1
            };
        }
    }

}

//--------------------------------SUM---------------------------------

function sumOfColumns(sheet: any, initialRow: any, finalRow: any, col: any,value?:any) {
    let sum = 0;
    if(!value){
        for (let row = initialRow; row <= finalRow; row++) {
            sheet.getRow(row).height = 25;
            const cellValue = Number(sheet.getCell(`${col}${row}`).value);
            if (typeof cellValue === 'number') {
                sum += cellValue;
            }
        }
    }else{
        sum = value;
    }

    const resultCell = sheet.getCell(`${col}${finalRow + 1}`);
    resultCell.value = sum;
    resultCell.alignment = { horizontal: 'center', vertical: 'middle' }; // Centrar la celda
}

async function setSum(sheet: any, type: any, row: any, styleHeaders: any, itemsOneLevel: any,configuration:any,sum?:any) {
    sheet.getRow(row).height = 15;
    sheet.getCell(`A${row}`).value = itemsOneLevel;

    const headers = ["Total Weight Kg","Quantity","Weight","CBM"];
    for (let i = 0; i <= headers.length - 1; i++) {
        if(configuration.orderHeaders[headers[i]]){
                    const col = configuration.orderHeaders[headers[i]].charAt(0);
        sumOfColumns(sheet, 10, row - 1, col,sum && sum[headers[i]] ? sum[headers[i]]:undefined);
        }
    }

    //----------------------styles----------------------------
    const startRow = row;
    const endRow = row;
    const startCol = 1; // A = 1
    const endCol = configuration.lastColumnNumber; // H = 8

    for (let rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
        for (let colIndex = startCol; colIndex <= endCol; colIndex++) {
            const cell = sheet.getCell(rowIndex, colIndex);
            // Aplicar estilos a cada celda
            cell.style = {
                ...styleHeaders
            };
        }
    }
}

//------------------------------------------------------------
function f_getCustomFieldsValuesArr(obj: any = {}) {
    const result: any = {};

    if (obj.customFields) {
        const customFields = obj.customFields;
        // Case: Multiple CustomFields (array of fields)

        customFields.forEach((customField: any) => {
            const internalName: string = customField.internalName;
            const value = customField.value || '';
            result[internalName] = value;
        });
    }

    return result;
}

//-------------------------Get data---------------------------
const getDataFromProduct = (product: any, brand: any,cartonsViewed:number = -1) => {
    const result: any = {};
    result.partNumber = product?.CLPartNumber || '';
    result.description = cartonsViewed != -1 ? `${cartonsViewed+1}-${cartonsViewed + product.children?.length}` :product?.CLDescription || ''; //Para cuando sea pagina 2
    result.quantity = product?.CLPieces || '';
    result.PalletID = product?.CLPalletID ? `${product.CLPalletID}` : '';
    result.UPC = product?.SkUpc || '';
    result.PackageType = product?.CLPackageName || '';
    result.Pallet = product.CLPalletID || "" ;
    result.Cartons = cartonsViewed != -1 ? product.children?.length: 0;

    //-------------CFS-----------------
    result.eanCode = ""
    result.style = "";
    result.size = "";
    result.color =  "";
    result.season = "";
//-------------------------------



    result.pcsXCtn = 0;
    result.totalCtn = 0;
    if (product?.customFields) {
        const customFields = f_getCustomFieldsValuesArr(product); // Assume this function is defined elsewhere
        // result.pcsXCtn = customFields?.ctnsitem || 0;
        // result.totalCtn = result.pcsXCtn * result.quantity;
        result.eanCode = customFields.ean_code || '';
        result.style = customFields.style  || '';
        result.size = customFields.sizes  || '';
        result.color =  customFields.color  || '';
        result.season = customFields.season  || '';

    }

    // Adjust quantities for specific brands
    const upperBrand = brand?.toUpperCase();
    if (upperBrand === 'LEGO' || upperBrand === 'GOLI') {
        const temp = result.quantity;
        result.quantity = result.totalCtn;
        result.totalCtn = temp;
    }

    return result;
};
//----------------------------DRAW ROW-----------------------------------
function drawRows(sheet: any, objData: any, fila: any, type: any,configuration:any) {
    const headers = ["Pallet","Cartons","UPC", "Part Number","Ean Code","Description","Style","Size","Color","Season","Quantity"]
    const keys = ["Pallet","Cartons","UPC", "partNumber","eanCode","description","style","size","color","season","quantity"]
    for (let i = 0; i <= headers.length - 1; i++) {
        if(configuration.orderHeaders[headers[i]]){
            const col = configuration.orderHeaders[headers[i]].charAt(0);
            const cell = sheet.getCell(`${col}` + fila);
            cell.value = objData[keys[i]];
            if (keys[i] == "description") {
                sheet.getCell(`${col}` + fila).alignment = { wrapText: true };
            }

            cell.style = styleCell;
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        }
    }
}
function drawRowsContainer(sheet: any, objData: any, initialRow: number, finalRow: number, type: any, level: number,configuration:any) {
    let firstColumn = "A" + initialRow;
    if (type === 1) {
        // result = printItemsInExcelCase1(data, organizedItems, worksheet, brand, typeOfCr);
    } else if (type === 2) {
        //si es dos niveles, la columna iniical es..
        firstColumn = "A" + initialRow;
    } else if (type === 3) {
        //si es tres niveles, la columna iniical es..
        if (level == 2) {
            firstColumn = "B" + initialRow;
        } else if (level == 1) {
            firstColumn = "A" + initialRow;
        }
    }
    const valueCotainer = objData.PalletID ? objData.PalletID:objData.PackageType;
    sheet.getCell(`${firstColumn}`).value = valueCotainer;
    sheet.getCell(`${firstColumn}`).style = styleCell;
    sheet.getCell(`${firstColumn}`).alignment = { horizontal: 'center', vertical: 'middle' };
    mergeCells(sheet, initialRow, finalRow, [`${firstColumn.charAt(0)}`]);
}
//-------------------------------------------------------------
function getDataFromBox(box: any) {
    return {
        Weight: parseFloat(parseFloat(box.CLWeight || 0).toFixed(2)),
        Length: parseFloat(parseFloat(box.CLLength || 0).toFixed(2)),
        Width: parseFloat(parseFloat(box.CLWidth || 0).toFixed(2)),
        Height: parseFloat(parseFloat(box.CLHeight || 0).toFixed(2)),
        Volume: parseFloat(parseFloat(box.CLVolume || 0).toFixed(2)),
        PalletID: box.PalletID ? ` - ${box.PalletID}` : '',
    };
}

function mergeCells(sheet: any, filaInicial: number, filaFinal: number, columnas: any) {
    try {
        columnas.forEach((columna: any) => {
            const rango = `${columna}${filaInicial}:${columna}${filaFinal}`;
            sheet.mergeCells(rango);
        });    
    } catch (error) {
        console.log(" There was an error!!! in Merge CELLS");
        console.log(error)
        console.log(`filaInicial: ${filaInicial}, filaFinal: ${filaFinal}, columns: ${columnas}`);
    }
}

function hasThreeLevels(item: any): boolean {
    if (!item.children || !Array.isArray(item.children) || item.children.length === 0) {
        return false;
    }

    return item.children.some((child: any) => 
        Array.isArray(child.children) && child.children.length > 0
    );
}

//--------------------------PRINT ITEMS 1-------------------------------
function processPallet({
    pallet,
    level = 0,
    sheet,
    currentRow,
    typeOfCr,
    itemCounter,
    brand,
    configuration,
    onlyFirstLevel = false, //to build a second page
    cartonsViewed

}: ProcessPalletParams): ProcessPalletResult {
    level += 1;
    // Validate required parameters
    if (!pallet || !sheet) {
        throw new Error("Invalid arguments: 'pallet' and 'sheet' are required.");
    }
    if (!pallet.children || pallet.children.length === 0 || onlyFirstLevel) {
        const updated = writeItem({
            item: pallet,
            sheet,
            currentRow,
            typeOfCr,
            itemCounter,
            brand,
            level,
            configuration,
            cartonsViewed

        });
        return updated;
    } else {
        for (const child of pallet.children) {
            const updated = processPallet({
                pallet: child,
                level: level,
                sheet,
                currentRow,
                typeOfCr,
                itemCounter,
                brand,
                configuration
            });
            currentRow = updated.currentRow;
            itemCounter = updated.itemCounter;
        }
        //Print the father! 
        const updated = writeItemContainer({
            item: pallet,
            sheet,
            currentRow,
            typeOfCr,
            itemCounter,
            brand,
            level,
            configuration
        });
        return updated;
    }
    return { currentRow, itemCounter };
}

function writeItem({
    item,
    sheet,
    currentRow,
    typeOfCr,
    itemCounter,
    brand,
    level,
    configuration,
    cartonsViewed=-1,

}: WriteItemParams): WriteItemResult {
    if (!item || !sheet) {
        throw new Error("Invalid arguments: 'item' and 'sheet' are required.");
    }
    const itemData = getDataFromProduct(item, brand,cartonsViewed);
    drawRows(sheet, itemData, currentRow, typeOfCr,configuration);
    currentRow++;
    itemCounter++;
    if(cartonsViewed != -1){
        cartonsViewed += itemData.Cartons;
    }
    //cambios para cartonsViewed
    return { currentRow, itemCounter,cartonsViewed};
}

// Created to print only items like carton and Pallets.
function writeItemContainer({
    item,
    sheet,
    currentRow,
    typeOfCr,
    itemCounter,
    brand,
    level,
    configuration
}: WriteItemParams): WriteItemResult {
    if (!item || !sheet) {
        throw new Error("Invalid arguments: 'item' and 'sheet' are required.");
    }
    const itemData = getDataFromProduct(item, brand);
    let startContainer = (currentRow - item.children.length);
    if (typeOfCr === 3 && level == 1 ) {
        const  numberNestedChildren = countNestedChildren(item);
        startContainer = (currentRow - numberNestedChildren);
    }    
    drawRowsContainer(sheet, itemData, startContainer, currentRow - 1, typeOfCr, level,configuration);
    itemCounter++;
    return { currentRow, itemCounter };
}

function countNestedChildren(father: any): number {
    if (!father.children || father.children.length === 0) {
        return 1;
    }
    let count = 0;
    for (const child of father.children) {
        count += countNestedChildren(child);
    }
    return count;
}

async function printItemsInExcelCase1(dataJson: any, organizedItems: any, sheet: any, brand: any, typeOfCr: any,configuration:any,page2 = false) {
    const inicio = 10;
    let currentRow = 10;
    let colCont1 = 1;
    let itemCont = 0;
    let col1 = inicio;
    let cartonsViewed = !page2 ? -1:0;
    let sum:any = {"Weight":0,"CBM":0,};
    if (organizedItems) {
        let itemCounter = 0;
        for (const pallet of organizedItems) {
            if(page2 == true && !hasThreeLevels(pallet)){
                continue;
            }
            ({ currentRow, itemCounter, cartonsViewed=0} = processPallet({
                pallet,
                level: 0,
                sheet,
                currentRow,
                typeOfCr,
                itemCounter,
                brand,
                configuration,
                onlyFirstLevel: page2 == true ? true:false,
                cartonsViewed
                
            }));
            const dimentions: any = getDataFromBox(pallet);
            const headers = ["Total Weight Kg","Weight", "Length", "Width", "Height", "CBM"]
            const keys = ["Weight","Weight", "Length", "Width", "Height", "Volume"]
            for (let i = 0; i <= headers.length - 1; i++) {
                if(configuration.orderHeaders[headers[i]]){
                    //------------cell-------------------
                    const col = configuration.orderHeaders[headers[i]].charAt(0);
                    const cellRef = `${col}${col1}`;
                    const cell = sheet.getCell(cellRef);
                    //------------------------------------
                    const rawValue = Number(dimentions[keys[i]]);
                    const value = Math.round(rawValue * 100) / 100;

                    cell.value = value;                          
                    cell.numFmt = '0.00';                      
                    cell.style = { ...styleCell, numFmt: '0.00' }; 
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    if (headers[i] in sum) {
                        sum = {
                            ...sum,
                            [headers[i]]: sum[headers[i]] + value,
                        }
                    }
                }
            }
            //MergeLast Cells
                const col =  configuration.orderHeaders[headers[0]] ?configuration.orderHeaders[headers[0]].charAt(0):configuration.orderHeaders[headers[1]].charAt(0); 
                const arrayLetters = generateColumnsFromLetter(col);
                mergeCells(sheet, col1, currentRow - 1, arrayLetters);
            colCont1++;
            itemCont++;
            col1 = currentRow;

        }
    }
    return {
        col1,
        colCont1,
        itemCont,
        sum
    };
}

function generateColumnsFromLetter(startLetter: string) {
    const columns = [];
    const letterCode = startLetter.charCodeAt(0);
    for (let i = 0; i < 5; i++) {
        columns.push(String.fromCharCode(letterCode + i));
    }
    return columns;
}

//-------------------------------------------------------------------

export async function descargarExcelDesdeJSON(data: any,groupName: string) {
    const { OperationData, comodityData } = data;
    if (!OperationData) {
        console.log("No se encontraron Datos para OperationData");
    }

    const number = OperationData?.Number || '';

    if (!comodityData) {
        console.log("No se encontraron Items");
        return "No se encontraron Items";
    }

    // const typeOfCr = GetCasePL(comodityData);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1', {
        views: [{ showGridLines: false }]
    });
    const organizedItems = organizeHierarchy(comodityData);
    const {typeOfCr,dynamicColumns} = verificarNivel(organizedItems);

    const objData: any = {
        date: new Date(OperationData.CreatedOn).toLocaleDateString('en-US'),
        customer: OperationData.ReleasedToName || '',
        SupplierPONumber: OperationData.SupplierPONumber || '',
    };
    // const isCustomerGabes = objData.customer === "GABE'S";
    let brand = '';
    let invoiceN = 'invoiceN';
    let po = '';
    let boxcf:any = {};

    if (OperationData.customFields) {
        boxcf = f_getCustomFieldsValuesArr(OperationData);
        console.log(boxcf,"boxcf");
        brand = boxcf.brand_auto || '-';
        // eslint-disable-next-line no-useless-escape
        invoiceN = groupName == "cargoReleaseViewList" ? (boxcf.so_number?.replace(/[\/:<>|"]/g, '') || 'invoiceN'):boxcf.so_number?.replace(/[\/:<>|"]/g, '') || "invoiceN"; 
        po = boxcf.purchaseorder || '';
    }

    const configuration = generateHeaderConfiguration(typeOfCr,boxcf);


    // const nameColumn = getNameFirstColumn(data, brand);
    objData.invoiceN = invoiceN;
    objData.brand = brand;
    objData.po = po;

    workbook.creator = 'INNOBO';
    workbook.lastModifiedBy = 'INNOBO';
    workbook.created = new Date();
    workbook.modified = new Date();


    const optionsPage1 = {
        typeOfCr: typeOfCr, // "2 Levels", "1 Level", or others
        nameColumn: dynamicColumns,
        styleArray1: styleHeaders,
        styleArrayFS: styleTitle,
        isPage2: false, // To toggle between the main and secondary header
    }

    const optionsPage2 = {
        typeOfCr: typeOfCr, // "2 Levels", "1 Level", or others
        nameColumn: dynamicColumns,
        styleArray1: styleHeaders,
        styleArrayFS: styleTitle,
        isPage2: true, // To toggle between the main and secondary header
    }

    await setHeader(worksheet, objData, optionsPage1,configuration);
    worksheet.name = invoiceN;
    //----------------- print data--------------------------------------
    const {col1,colCont1,itemCont,sum} = await  printItemsInExcelCase1(data, organizedItems, worksheet, brand, typeOfCr,configuration);
    await setSum(worksheet, typeOfCr,col1,styleHeaders,organizedItems.length,configuration,sum);

    //-------------------------------------------PAGE 2---------------------------------

    if(typeOfCr && typeOfCr >= 3){
        const worksheet2 = workbook.addWorksheet('Sheet 2', {
            views: [{ showGridLines: false }]
        });
        const configurationPage2 = generateHeaderConfiguration(1,boxcf,2);
        await setHeader(worksheet2, objData, optionsPage2,configurationPage2);
        const {col1:col2,colCont1:colCont2,itemCont:itemCont2,sum} = await  printItemsInExcelCase1(data, organizedItems, worksheet2, brand, typeOfCr,configurationPage2,true);
        await setSum(worksheet2, typeOfCr,col2,styleHeaders,itemCont2,configurationPage2);

        worksheet2.name = `${invoiceN}-2`;
    }
    //-------------------------------------------------------------------------------------
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${number}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}




